<template>
  <div>
    <header class="toolbar">
      <div class="l-container">
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <h1 class="toolbar__title">Multi-Factor Authentication</h1>
            </template>
          </c-level>
        </div>
      </div>
    </header>
    <c-panel class="l-container" v-if="isDataLoaded && !profile.is_mfa_enabled">
      <c-row justify="center">
        <c-col span="12">
          <p>Multi-factor authentication is not enabled. To enable it:</p>
          <ul>
            <li>Download one of the Authenticator App on your phone, or any TOTP/HOTP Authenticator (like Google Authenticator)</li>
            <li>Scan the QR code below</li>
            <li>Enter the code from the application below and press <strong>Enable MFA</strong></li>
          </ul>
          <p>Please store the following key safely, you will need it if you want to migrate the authenticator
            configuration to a different phone: <strong>{{mfa.key}}</strong></p>
          <canvas id="qr" ref="qr1"></canvas>
          <c-form layout="inline">
            <c-form-field label="Authenticator code:">
              <c-form-input type="text" v-model="code"></c-form-input>
            </c-form-field>
            <c-form-field>
              <c-button type="primary" smart @click.prevent="onEnableMFA">Enable MFA</c-button>
            </c-form-field>
          </c-form>

        </c-col>
      </c-row>
    </c-panel>
    <c-panel class="l-container" v-if="isDataLoaded && profile.is_mfa_enabled && !profile.is_mfa_required">
      <c-row justify="center">
        <c-col span="12">
          <p>Multi-factor authentication is enabled. To disable it, enter the code from your authentication app below
            and press <strong>Disable MFA</strong></p>
          <c-form layout="inline">
            <c-form-field label="Authenticator code:">
              <c-form-input type="text" v-model="code"></c-form-input>
            </c-form-field>
            <c-form-field>
              <c-button type="primary" smart @click.prevent="onDisableMFA">Disable MFA</c-button>
            </c-form-field>
          </c-form>
        </c-col>
      </c-row>
    </c-panel>
    <c-panel class="l-container" v-if="isDataLoaded && profile.is_mfa_enabled && profile.is_mfa_required">
      <c-row justify="center">
        <c-col span="12" class="u-text-center">
          <i class="icon-warning2 u-color-warning u-fs-64"></i>
        </c-col>
      </c-row>
      <c-row justify="center">
        <c-col span="12">
          <p>Multi-factor authentication is enabled. You cannot disable this feature as it is required by your client account settings.</p>
          <p><c-button type="primary" smart @click.prevent="onContinue">Continue</c-button></p>
        </c-col>
      </c-row>
    </c-panel>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import QRious from 'qrious'

export default {
  name: 'User2FA',

  computed: {
    ...mapState('auth', ['clientCode', 'is_mfa_enabled'])
  },

  data () {
    return {
      isDataLoaded: false,
      profile: null,
      mfa: null,
      code: ''
    }
  },

  mounted () {
    this.get_mfa()
      .then(() => this.get_enabled())
      .then(() => this.onRefresh())
  },

  methods: {
    ...mapMutations({
      setIsMfaEnabled: 'auth/setIsMfaEnabled'
    }),
    onContinue () {
      this.$router.push({name: 'UserHome'})
    },
    get_enabled () {
      return new Promise((resolve, reject) => {
        let url = process.env.API + 'user/profile'
        axios.get(url).then((response) => {
          this.isDataLoaded = true
          this.profile = response.data
          resolve()
        }).catch((reason) => {
          console.error('Could not get data')
          console.error(reason)
        })
      })
    },

    get_mfa () {
      return new Promise((resolve, reject) => {
        let url = process.env.API + 'user/mfa/new'
        axios.get(url).then((response) => {
          this.mfa = response.data
          // let w = new QRious(
          //   {
          //     element: document.getElementById('qr'),
          //     value: x.mfa.uri
          //   })
          resolve()
        }).catch((reason) => {
          console.error('Could not get MFA data')
          console.error(reason)
          // reject('Could not get MFA data')
        })
      })
    },

    onRefresh () {
      // eslint-disable-next-line no-new
      new QRious(
        {
          element: document.getElementById('qr'),
          value: this.mfa.uri,
          size: 250
        })
    },

    onEnableMFA () {
      let url = process.env.API + 'user/mfa'
      axios.post(url, {
        key: this.mfa.key,
        code: this.code
      }).then((response) => {
        this.$snotify.success(
          'MFA enabled!',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
        this.profile.is_mfa_enabled = true
        this.setIsMfaEnabled(true)
        this.code = null
      }).catch((reason) => {
        console.error('Could not enable MFA')
        console.error(reason)
        this.$snotify.error(
          'Could not enable MFA',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
      })
    },

    onDisableMFA () {
      let url = process.env.API + 'user/mfa?code=' + this.code
      axios.delete(url).then((response) => {
        this.$snotify.success(
          'MFA Disabled!',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
        this.profile.is_mfa_enabled = false
        this.setIsMfaEnabled(false)
        this.code = null
        let x = this
        setTimeout(() => x.onRefresh(), 100)
        // this.onRefresh()
      }).catch((reason) => {
        console.error('Could not disable MFA')
        console.error(reason)
        this.$snotify.error(
          'Could not disable MFA',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/User2FA.vue